import sdl from '@jds/react-generated-sdl/JDSNotificationBanner';
import type { JDSNotificationBannerProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, NotificationBannerProps } from '../logic';

const Component = (props: NotificationBannerProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    global = false,
    open = true,
    closeOnSuffixClick = true,
    ctaPosition = 'inline',
    ariaLabel = props.title?.toString(),
    closeButtonAriaLabel = 'Close Button',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      global,
      open,
      closeOnSuffixClick,
      ctaPosition,
      ariaLabel,
      closeButtonAriaLabel,
      ...rest
    },
    'JDSNotificationBanner',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const NotificationBanner = withLogic(
  Component
) as React.FC<NotificationBannerProps> & { slotName?: string };

NotificationBanner.displayName = 'NotificationBanner';
NotificationBanner.slotName = 'jds_notification_banner';

export { NotificationBanner, type JDSNotificationBannerProps };
